import React from 'react'
import Link from 'gatsby-link'
import './Navigation.sass'

const ACTIVE = 'is-active'

const Navigation = () => (
  <nav className="Navigation" role="navigation">
    <Link to="/treninky" activeClassName={ACTIVE}>tréninky</Link>
    <Link to="/treneri" activeClassName={ACTIVE}>trenéři</Link>
    <Link to="/muvko-people" activeClassName={ACTIVE}>muvko people</Link>
    <Link to="/akce" activeClassName={ACTIVE}>akce</Link>
    <Link to="/kontakt" activeClassName={ACTIVE}>kontakt</Link>
  </nav>
)

export default Navigation



// WEBPACK FOOTER //
// ./src/components/Navigation/index.js